module.exports = __webpack_public_path__ + "img/footer_ico_add.60300155.png";